import type { ProductCode } from "@fd/tokens";
import lookout from "../assets/brand/Lookout-Icon-New.svg";
import wave from "../assets/brand/Wave-Icon-New.svg";
import backhaul from "../assets/brand/Backhaul-Icon-New.svg";
import sentinel from "../assets/brand/Sentinel-Icon-New.svg";
import affinity from "../assets/brand/Affinity-Icon-New.svg";

export type ProductIconSize = "xs" | "sm" | "md" | "lg";

export interface ProductIconProps {
  product: ProductCode;
  size?: ProductIconSize;
  /** Override the official SVG if needed; defaults to the bundled brand asset. */
  src?: string;
}

// Official Future Demand product icons (teal/olive background + navy glyph baked in).
const SRC: Record<ProductCode, string> = { lookout, wave, backhaul, sentinel, affinity };

const LABEL: Record<ProductCode, string> = {
  lookout: "Lookout",
  wave: "Wave",
  backhaul: "Backhaul",
  sentinel: "Sentinel",
  affinity: "Affinity",
};

const sizeClass: Record<ProductIconSize, string> = {
  xs: "fd-product-icon--xs",
  sm: "fd-product-icon--sm",
  md: "",
  lg: "fd-product-icon--lg",
};

export function ProductIcon({ product, size = "md", src }: ProductIconProps) {
  const cls = ["fd-product-icon", sizeClass[size]].filter(Boolean).join(" ");
  return (
    <span className={cls} role="img" aria-label={LABEL[product]}>
      <img src={src ?? SRC[product]} alt="" />
    </span>
  );
}
